var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTejastejalites(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1317.77 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c66834;}.cls-2{fill:#ea763b;}.cls-3{clip-path:url(#clippath-1);}.cls-4{fill:none;}.cls-5{fill:#009ee2;}.cls-6{fill:#b65e31;}.cls-7{fill:#ef8050;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 588.61,
    cy: 540,
    r: 457.67
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 1080,
    height: 1080
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 588.61,
    cy: 540,
    r: 457.67
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M655.95,175.48c-.94,9.56,33,29.93,38.86,39.21,14.88,15.97,29.97,52.27,29.97,52.27l108.85,62.65c61.65,6.8,79.48-18.12,151.42,37.09,21.4,17.85,26,47.64,31.28,58.47,1.06,2.18,2.92,4.09,5.24,5.39l110.51,61.92c7.48,5.75,47.5,1.85,55.75,3.02,19.25,6.03,43.65,12.59,63.8,.08l9.7,2.92,8.36,6.64,3.86,6.35c14.31,14.22,12.4-3.96,33.64,26.71,5.15,1.74,8.74-1.58,10.58-4.35-30.3-63.18-95.08-67.22-151.21-67.86-2.28-.14-4.59-.85-6.67-2.03l-116.77-65.7c-14.44-12.15-26.75-48.77-40.62-60.94-52.98-48.68-82.99-35.04-141.96-41.72,0,0-114.71-64.1-114.71-64.1-8.41-3.8-12.24-14.35-16.38-20.91-3.37-6.94-14.24-5.61-20.2-6.36-20.25-12.62-5.05-22.6-26.33-18.77-5.14-1.68-24.36-17.11-26.97-9.99Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "518.83 871.98 382.57 787.58 1050.11 400.64 1175.95 467.4 518.83 871.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1010.25,347.02l-1.46-1c-18.53-21.91-40.95-43.68-83.03-46.77-.25-.02-15.2-1.06-15.45-1.02l-53.2,31.53L218.3,694.65s60.35,4.61,60.6,4.57c34.09-4.98,51.77,6.39,79.8,24.08l15.48,13.8L1010.25,347.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M365.35,733.96s10.83,9.21,30.43,32.5c10.76,12.8,18.73,16.77,18.73,16.77l639.65-381.57s-15.53-3.52-22.75-22.81c-7.3-19.49-21.92-32.43-21.92-32.43L365.35,733.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.39,597.82s-4.39,.39-13.81-10.95c-9.43-11.34-10.56-8.92-10.56-8.92L724.96,206.13c.3-1.45,7.98,4.03,9.41,10.76,.88,4.13,9.82,13.75,9.82,13.75L120.39,597.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.73,569.07s-8.44-1.01-12.13-7.35c-5.24-9.02-6.86-11.85-6.86-11.85L693.96,185.44s.69,1.48,2.41,3.59c1.79,2.19-1.44,4.51,4.01,7.78,6.61,3.95,6.21,7.57,6.21,7.57L86.73,569.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.16,551.67s-3.42-.42-7.98,1.02c-2.99,.94-4.46-6.32-6.18-7.38-10.71-6.62-17.82-9.53-17.82-9.53L658.18,173.35s5.39,2.18,12.39,5.36c3.96,1.8,8.4,5.99,13,5.76,3.94-.2,9.79,.97,9.79,.97L66.16,551.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.22,586.17l-2.21-4.39-1.41-3.59-6.8-3.58L705.05,204.7s2.44,.23,6.2-.14c1.48-.14,6.15-1.02,9.12-.71,3.68,.39,5.61,2.01,5.61,2.01L84.22,586.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1317.61,537.44s-18.49-99.33-157.18-69.23L507.02,863.72s106.23-10.66,154.57,54.97c0,0,11.21,4.13,5.05,5.61l4.57,7.15,645.88-389.43,.52-4.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "260.6 683.09 101.51 608.25 742.56 230.6 860.54 295.6 912.32 298.49 260.6 683.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M33.48,536.6c-1.41,9.5,31.49,31.51,36.9,41.07,14.08,16.68,27.37,53.67,27.37,53.67l105.65,67.91c61.24,9.81,80.27-14.2,149.42,44.47,20.5,18.88,23.63,48.86,28.37,59.93,.96,2.23,2.72,4.23,4.97,5.64l107.34,67.26c7.19,6.11,47.35,4.18,55.54,5.75,18.93,6.96,42.98,14.71,63.72,3.2l9.54,3.4,8.02,7.04,3.55,6.53c13.59,14.91,12.58-3.35,32.29,28.33,5.06,1.99,8.8-1.15,10.78-3.83-27.17-64.59-91.67-71.8-147.7-75.2-2.27-.26-4.54-1.07-6.57-2.36l-113.41-71.34c-13.82-12.84-24.32-50.02-37.58-62.86-50.53-51.22-81.17-39.07-139.74-48.63,0,0-111.43-69.64-111.43-69.64-8.22-4.21-11.52-14.93-15.34-21.69-3.02-7.1-13.95-6.3-19.87-7.34-19.61-13.6-3.94-22.82-25.38-20.03-5.05-1.93-23.49-18.29-26.45-11.3Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "606.3 658.06 382.86 787.58 519.12 871.98 606.3 818.31 606.3 658.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M606.3,473.19l-387.72,221.46s60.35,4.61,60.6,4.57c34.09-4.98,51.77,6.39,79.8,24.08l15.48,13.8,231.84-142.18v-121.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M606.3,589.17l-240.66,144.79s10.83,9.21,30.43,32.5c10.76,12.8,18.73,16.77,18.73,16.77l191.5-114.24v-79.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M606.3,276.45L96.64,577.75c.77-.14,3.18,.65,10.22,9.12,9.43,11.34,13.81,10.95,13.81,10.95l485.62-285.84v-35.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M606.3,236.62L68.04,549.87s1.61,2.84,6.86,11.85c3.69,6.34,12.13,7.35,12.13,7.35L606.3,263.55v-26.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M606.3,203.65L34.45,535.78s7.11,2.91,17.82,9.53c1.72,1.06,3.19,8.32,6.18,7.38,4.56-1.44,7.98-1.02,7.98-1.02L606.3,236.44v-32.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "606.3 262.73 74.09 574.61 80.89 578.19 82.3 581.78 84.51 586.17 606.3 276.96 606.3 262.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M606.3,803.8l-98.99,59.92s51.42-5.13,98.99,13.84v-73.76Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "606.3 311.04 101.8 608.26 260.89 683.09 606.3 479.25 606.3 311.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M606.3,863.7c-24.52-8-51.5-10.37-76.77-11.9-2.27-.26-4.54-1.07-6.57-2.36l-113.41-71.34c-13.83-12.84-24.32-50.02-37.58-62.86-50.53-51.22-81.17-39.07-139.74-48.63,0,0-111.43-69.64-111.43-69.64-8.22-4.21-11.52-14.93-15.34-21.69-3.02-7.1-13.95-6.3-19.87-7.34-19.61-13.6-3.94-22.82-25.38-20.03-5.05-1.93-23.49-18.29-26.45-11.3-1.41,9.5,31.49,31.51,36.9,41.07,14.08,16.68,27.37,53.67,27.37,53.67l105.65,67.91c61.24,9.81,80.27-14.2,149.42,44.47,20.5,18.88,23.64,48.86,28.37,59.93,.96,2.23,2.72,4.23,4.97,5.64l107.34,67.26c7.19,6.11,47.35,4.18,55.54,5.75,16.91,6.22,37.9,12.97,56.98,6.14v-24.77Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTejastejalites);
export default __webpack_public_path__ + "static/media/Tejas tejalites.f01aba0fc3034d6e594197cd69ce7b80.svg";
export { ForwardRef as ReactComponent };